import type { ApiJsonRequestBody } from '../contracts'

export const PURCHASE_REQUESTS_API_PREFIX = '/api/purchaserequests'

export type CreatePurchaseRequestContract = ApiJsonRequestBody<'createPurchaseRequest'>
export type AddPurchaseRequestCommentContract = ApiJsonRequestBody<'addPurchaseRequestComment'>
export type AssignPurchaseRequestAssigneeContract = ApiJsonRequestBody<'assignPurchaseRequestAssignee'>
export type UpdatePurchaseRequestStatusContract = ApiJsonRequestBody<'updatePurchaseRequestStatus'>
export type UpdatePurchaseRequestDeletedContract = ApiJsonRequestBody<'updatePurchaseRequestDeleted'>
export type SplitPurchaseRequestContract = ApiJsonRequestBody<'splitPurchaseRequestItems'>
export type CreatePurchaseRequestRevisionContract = ApiJsonRequestBody<'createPurchaseRequestRevision'>

export function createSuggestionSearchParams(query: string, limit: number): URLSearchParams | null {
  const normalizedQuery = query.trim()
  if (!normalizedQuery) {
    return null
  }

  const params = new URLSearchParams()
  params.set('query', normalizedQuery)
  params.set('limit', String(limit))

  return params
}
